// @ts-ignore
interface Date {
    toLocalISOString(): string;
}

// eslint-disable-next-line
interface DateConstructor {
    fromLocalDate: (value: string) => Date;
}

// eslint-disable-next-line
Date.prototype.toLocalISOString = function () {
    const tzo = -this.getTimezoneOffset();
    const dif = tzo >= 0 ? '+' : '-';
    const pad = (num: number) => {
        const norm = Math.floor(Math.abs(num));
        return (norm < 10 ? '0' : '') + norm;
    };

    return this.getFullYear() +
        '-' + pad(this.getMonth() + 1) +
        '-' + pad(this.getDate()) +
        'T' + pad(this.getHours()) +
        ':' + pad(this.getMinutes()) +
        ':' + pad(this.getSeconds()) +
        dif + pad(tzo / 60) +
        ':' + pad(tzo % 60);
}

Date.fromLocalDate = (value: string) => {
    const date = new Date(value);
    const tzo = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() + tzo);

    return date;
}


// eslint-disable-next-line
interface String {
    padStart(targetLength: number, padString: string): string;
}

if (!String.prototype.padStart) {
    // eslint-disable-next-line
    String.prototype.padStart = function padStart(targetLength: number, padString: string) {
        // tslint:disable-next-line:no-bitwise
        targetLength = targetLength >> 0; // truncate if number, or convert non-number to 0;
        padString = String(typeof padString !== 'undefined' ? padString : ' ');
        if (this.length >= targetLength) {
            return String(this);
        } else {
            targetLength = targetLength - this.length;
            if (targetLength > padString.length) {
                padString += padString.repeat(targetLength / padString.length); // append to original to ensure we are longer than needed
            }
            return padString.slice(0, targetLength) + String(this);
        }
    };
}